import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExternalLinkService {
  private pendingUrl = '';
  readonly isModalVisible$ = new BehaviorSubject<boolean>(false);

  open(url: string): void {
    this.pendingUrl = url;
    this.isModalVisible$.next(true);
  }

  confirm(): void {
    window.open(this.pendingUrl, '_blank');
    this.close();
  }

  cancel(): void {
    this.close();
  }

  private close(): void {
    this.pendingUrl = '';
    this.isModalVisible$.next(false);
  }
}
